import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { ZoneApi } from "@/Modules/Models/Api/OnBoarding";
import type { ZoneData } from "@/Modules/Models/Domain/OnBoarding";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";

const TimeZoneApiToTimeZoneTransformer: TransformerExtended<ZoneData, ZoneApi> = {
  ...DefaultTransformerGenerator<ZoneData, ZoneApi>(),

  toDomain(zonesApi: ZoneApi) {
    return camel<ZoneApi, ZoneData>(zonesApi);
  },
};

export type TimeZoneApiToTimeZoneTransformerType = TransformerExtended<ZoneApi, ZoneData>;

export default TimeZoneApiToTimeZoneTransformer;
